import kformUtils from "../../utils/kform-utils";

const isNumeric = (/** @type {any} */ n) => !Number.isNaN(Number.parseFloat(n)) && Number.isFinite(n);

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.maskOptions = {
		padFractionalZeros: $scope.component.requireDecimal,
		scale:              $scope.component.decimalLimit,
	};

	if ($scope.options?.building) {
		return;
	} // FOR-71 - Skip parsing input data.

	// Ensure that values are numbers.
	if ($scope.data && Object.prototype.hasOwnProperty.call($scope.data, $scope.component.key)) {
		if (Array.isArray($scope.data[$scope.component.key])) {
			for (const [index, entry] of $scope.data[$scope.component.key].entries()) {
				if (!isNumeric(entry)) {
					$scope.data[$scope.component.key][index].name = Number.parseFloat(entry.name);
				}
			}
		}
		else if ($scope.data[$scope.component.key] !== undefined && !isNumeric($scope.data[$scope.component.key])) {
			$scope.data[$scope.component.key] = Number.parseFloat($scope.data[$scope.component.key]);
		}
	}

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};

	$scope.isRequired = (
		/** @type {any} */ component,
		/** @type {any[]} */ componentsToRequire,
	) => {
		return (component.isRequired())
			|| (Array.isArray(componentsToRequire) && componentsToRequire.includes(component.key));
	}
};
